import { AuthEvents } from "./events/auth";
import { PlaybookEvents } from "./events/playbook";
import { RiskAnalysisEvents } from "./events/risk-analysis";
import { AddinEvents } from "./events/addin";
import { UserEvents } from "./events/user";
import { WordEvents } from "./events/word";
import { RedlinesEvents } from "./events/redlines";
export * from "./keys";

export type AnalyticsEvent = AuthEvents &
  PlaybookEvents &
  RiskAnalysisEvents &
  AddinEvents &
  UserEvents &
  WordEvents &
  RedlinesEvents;
